import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withStyles, CircularProgress, Grid, Link } from '@material-ui/core';
import { LinkOff as LinkOffIcon } from '@material-ui/icons';
import { FHEContainerForm, FHEContainerScroll, FHEItemText, ProductTitle, FHEMiniFormEditButton, FHETextField } from 'data/components';
import { Toastr, Logger, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { dissociateProduct, updateProductField } from '../../../../../../data/Products/actions';

class FheBasicForm extends PureComponent {
    static propTypes = {
        updateProductField: PropTypes.func.isRequired,
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        identifier: PropTypes.string.isRequired,
        homeId: PropTypes.string.isRequired,
        homeLabel: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        version: PropTypes.string.isRequired,
        status: PropTypes.string.isRequired,
        state: PropTypes.string.isRequired,
        addressIp: PropTypes.string.isRequired,
        refreshStatusProduct: PropTypes.func.isRequired,
        classes: PropTypes.object.isRequired,
        dissociateProduct: PropTypes.func.isRequired,
        children: PropTypes.object
    };

    static defaultProps = {
        children: null
    };

    constructor(props) {
        super(props);
        this.state = {
            formDisabled: true,
            textInput_error: {},
            sendLoading: false,
            form: this.getDataForm(),
            deleteLoading: false
        };
    }

    componentDidMount() {
        const { profile, history } = this.props;
        const userRight = profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('products_fhe_product_details');
        if (!userRight) {
            Logger.verbose('Redirect to 403');
            return history.replace('/error/403');
        }
    }

    navigateToHomeDetail = () => {
        const { homeId, history } = this.props;
        return history.push({
            pathname: `/${history.environment}/home/detail/${homeId}`
        });
    };

    dissociateProduct = () => {
        const { homeId, identifier, dissociateProduct, history, type } = this.props;

        return dissociateProduct('state', homeId, identifier, 'fhe_product', 'dissociated', type)
            .then(() => {
                Toastr.success(
                    Translator.translate(
                        `generic.products.table.action.dissociate.success`,
                        Translator.translate(`${history.environment}.centerName`)
                    )
                );
                return history.goBack();
            })
            .catch(err => {
                Toastr.error(
                    Translator.translate(`generic.products.table.action.dissociate.error`, Translator.translate(`${history.environment}.centerName`)),
                    err
                );
                throw err;
            });
    };

    refreshStatusProduct = () => {
        const { identifier, refreshStatusProduct } = this.props;
        return refreshStatusProduct('fhe_product', identifier);
    };
    askDissociateProduct = e => {
        const { history } = this.props;
        e.preventDefault();
        this.setState({ deleteLoading: true });
        Toastr.confirm(
            Translator.translate(`generic.products.table.action.dissociate.confirmRemove`),
            Translator.translate(`generic.products.table.action.dissociate.confirmRemoveTitle`),
            {
                onYes: () => {
                    this.dissociateProduct().catch(() => {
                        this.setState({ deleteLoading: false });
                    });
                },
                onNo: () => {
                    this.setState({ deleteLoading: false });
                }
            }
        );
    };

    formatForm = () => {
        const { form } = this.state;
        let newForm = form;
        Object.keys(form).forEach(key => {
            if (form[key] === '') {
                form[key] = null;
            }
        });
        this.setState({
            form: newForm
        });
    };

    getDataForm = () => {
        const { label } = this.props;
        return { label };
    };

    handleEdit = () => {
        const { formDisabled, form } = this.state;

        this.setState({
            formDisabled: !formDisabled,
            form: formDisabled ? { ...form } : this.getDataForm()
        });
    };

    validateForm = form => {
        const errors = {};

        if (tools.isEmpty(form.label)) {
            errors['label'] = Translator.translate('general.fields.error.any.empty');
        }

        this.setState({
            textInput_error: errors
        });

        return Object.keys(errors).length <= 0;
    };

    handleChange = event => {
        const { form, textInput_error } = this.state;
        const fieldLengthRules = {
            label: 255
        };

        const newTextInput_error = tools.removeKey(textInput_error, event.target.name);
        const value = tools.maxFieldLength(fieldLengthRules, form, event.target);

        this.setState({
            form: { ...form, [event.target.name]: value },
            textInput_error: newTextInput_error
        });
    };

    loadInputs = () => {
        this.setState({
            form: this.getDataForm(),
            formDisabled: true,
            textInput_error: {},
            sendLoading: false
        });
    };

    confirmEdit = async () => {
        const { form } = this.state;
        const { homeId, identifier, type, updateProductField, history } = this.props;

        this.formatForm();

        if (this.validateForm(form)) {
            this.setState({
                sendLoading: true,
                formDisabled: true
            });

            updateProductField('label', homeId, identifier, 'fhe_product', form.label, type)
                .then(() => {
                    Toastr.success(Translator.translate(`generic.products.actions.editLabelSuccess`, form.label));
                    this.loadInputs();
                })
                .catch(error => {
                    this.setState({
                        sendLoading: false,
                        formDisabled: false
                    });
                    Toastr.error(Translator.translate(`generic.products.actions.editLabelError`, form.label));
                    if (error.validation && error.validation.errors) {
                        return tools.handleFormError(
                            error.validation.errors,
                            Translator.translate(`generic.products.actions.editLabelError`, form.label)
                        );
                    }
                });
        }
    };

    render() {
        const { classes, identifier, homeId, homeLabel, type, version, status, state, children, addressIp, profile, history } = this.props;
        const { form, textInput_error, sendLoading, formDisabled, deleteLoading } = this.state;
        const userRights = profile.getIn(['user_rights', history.environment], []);
        const userRightDissociate = profile.get('admin') || userRights.includes(`products_${type}_dissociate`);
        const userRightRefreshStatus = profile.get('admin') || userRights.includes(`products_${type}_refreshStatus`);
        const userRightHomeDetails = profile.get('admin') || userRights.includes('homeDetails');
        const userRightUpdate = profile.get('admin') || userRights.includes(`products_${type}_update`);

        return (
            <Fragment>
                <ProductTitle homeLabel={homeLabel} type={type} />
                <FHEContainerScroll>
                    <FHEContainerForm>
                        <Grid container spacing={3}>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.identifier')}
                                    itemContent={identifier ? identifier.match(/.{1,2}/g).join(':') : 'N/A'}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    tooltip={Translator.translate(`general.showHome`)}
                                    itemTitle={Translator.translate('general.table.column.homeLabel')}
                                    itemContent={
                                        userRightHomeDetails ? (
                                            <Link component="button" onClick={this.navigateToHomeDetail}>
                                                {`#${homeId} ${homeLabel}`}
                                            </Link>
                                        ) : (
                                            `#${homeId} ${homeLabel}`
                                        )
                                    }
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.type')}
                                    itemContent={type}
                                    tooltip={Translator.translate(`general.${type}`)}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEMiniFormEditButton
                                    handleEdit={this.handleEdit}
                                    confirmEdit={this.confirmEdit}
                                    sendLoading={sendLoading}
                                    formDisabled={formDisabled}
                                    hasRightToEdit={userRightUpdate}
                                >
                                    <FHETextField
                                        disabled={formDisabled || !userRightUpdate}
                                        id="label"
                                        value={!form.label || form.label === null ? '' : form.label}
                                        error={textInput_error.label}
                                        helperText={textInput_error.label ? textInput_error.label : null}
                                        label={Translator.translate('general.table.column.label')}
                                        name="label"
                                        onChange={this.handleChange}
                                    />
                                </FHEMiniFormEditButton>
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText itemTitle={Translator.translate('general.table.column.version')} itemContent={version} />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    tooltip={Translator.translate(`generic.products.table.action.refresh.tooltip`)}
                                    onClick={userRightRefreshStatus ? this.refreshStatusProduct : null}
                                    itemTitle={Translator.translate('general.table.column.state')}
                                    itemContent={Translator.translate(`general.${status}`)}
                                    classContent={status === 'disconnected' ? classes.disconnectedColor : classes.connectedColor}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.status')}
                                    itemContent={Translator.translate(`general.${state}`)}
                                    classContent={state === 'dissociated' ? classes.disconnectedColor : classes.connectedColor}
                                    iconButton={
                                        !deleteLoading ? (
                                            <LinkOffIcon onClick={this.askDissociateProduct} />
                                        ) : (
                                            <CircularProgress size={20} color="inherit" />
                                        )
                                    }
                                    iconButtonTooltip={Translator.translate(`generic.products.table.action.dissociate.tooltip`)}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText itemTitle={Translator.translate('general.table.column.addressIp')} itemContent={addressIp} />
                            </Grid>
                        </Grid>
                    </FHEContainerForm>
                    {children}
                </FHEContainerScroll>
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const productKey = props.productKey;
    const product = state.environments[history.environment].data.Products.getIn(['list', productKey], new Map());
    const homes = state.environments[history.environment].data.Homes.get('list');
    return {
        profile: state.data.user,
        identifier: product.getIn(['identifier'], ''),
        homeId: product.getIn(['homeId'], '').toString(),
        homeLabel: homes.getIn([product.getIn(['homeId'], '').toString(), 'label'], ''),
        type: product.getIn(['type'], ''),
        label: product.getIn(['label'], ''),
        version: product.getIn(['version'], ''),
        status: product.getIn(['status'], ''),
        state: product.getIn(['state'], ''),
        addressIp: product.getIn(['addressIp'], '')
    };
}

const styles = theme => ({
    connectedColor: {
        color: theme.palette.success.main
    },
    disconnectedColor: {
        color: theme.palette.error.main
    }
});

export default withRouter(
    renderEnvComponent(
        'scenes/Products/components/Product/Fhe/FheBasicForm/index',
        connect(
            mapStateToProps,
            (dispatch, ownProps) =>
                bindActionCreators(
                    tools.mergePropsToAction(ownProps.history.environment, {
                        updateProductField,
                        dissociateProduct
                    }),
                    dispatch
                )
        )(withStyles(styles, { withTheme: true })(FheBasicForm))
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/Product/Fhe/BasicForm/index.js